<template>
    <div class="af-app af-search">
        <RouterView />
    </div>
</template>

<script>
    export default {
        name: 'App',

        data() {
            return {
            };
        },

        methods: {},
    };
</script>
